type Nil = undefined | null;

export default function isNil(val: unknown): val is Nil {
  return val == null;
}
